module.exports = __webpack_public_path__ + "static/media/photo62.7eea7709.jpg";